import { CSSObject } from "@emotion/react";

export const globalLayoutCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

export const mainCss: CSSObject = {
  display: "flex",
  flexGrow: 1,
  flexDirection: "column",
};

export const globalStyleOverrideCss = {
  body: {
    padding: 0,
    margin: 0,
    height: "100%",
  },
};
